export default __webpack_public_path__ + "static/media/woman-with-pencil-and-checklist.a86cafa1.svg";